// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ef1af76","732":"5fda8995","977":"08fc48ae"}[chunkId] + ".chunk.js";
};